module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/6-on-2d3bb85c499dd343289941e70a96cb9d.png";